import { useMemo } from "react";
import { useAppContext } from "../Context/AppContext";
import { isLoggedIn } from "../auth/authStorage";
import { isUnpaidExplorerUser } from "../explorer/isUnpaidExplorerUser";
import { useGetExplorerConnectionLimit } from "../api/queries/useGetExplorerConnectionLimit";

/**
 * Explorer-only weekly connection action budget (send + accept, max 1/week).
 * Unpaid users without Business/Executive/Early/Youth membership are Explorers.
 * Paid members always have unlimited actions.
 */
export function useExplorerConnectionLimit() {
  const { objectId, user } = useAppContext();
  const userId = objectId ?? "";
  const profile = user?.user;

  const isExplorer = useMemo(
    () => isUnpaidExplorerUser(profile),
    [profile]
  );

  const { data: limitData, refetch: refetchLimit } = useGetExplorerConnectionLimit({
    userId,
    enabled: isLoggedIn() && !!userId && isExplorer,
  });

  const canPerformConnectionAction = useMemo(() => {
    if (!isExplorer) return true;
    return limitData?.canPerformAction !== false;
  }, [isExplorer, limitData?.canPerformAction]);

  return {
    isExplorer,
    canPerformConnectionAction,
    used: limitData?.used ?? 0,
    limit: limitData?.limit ?? 1,
    remaining: limitData?.remaining ?? 1,
    weekResetsUtc: limitData?.weekResetsUtc,
    refetchLimit,
  };
}
